import { NAME } from './constants';
export const LOAD_LIST = `${NAME}/LOAD_LIST`;
export const ADD_FOLLOWING = `${NAME}/ADD_FOLLOWING`;
export const DELETE_FOLLOWING = `${NAME}/DELETE_FOLLOWING`;
export const CLEAR_FOLLOWING_LIST = `${NAME}/CLEAR_FOLLOWING_LIST`;

export const loadFollowingList = () => ({
  type: LOAD_LIST,
});

export const followPressroom = id => ({
  type: ADD_FOLLOWING,
  payload: { id },
});

export const unfollowPressroom = id => ({
  type: DELETE_FOLLOWING,
  payload: { id },
});

export const clearFollowingList = () => ({
  type: CLEAR_FOLLOWING_LIST,
});
